import React, { ReactElement } from 'react';
import IconButton from '../Buttons/IconButton/IconButton';
import Button from '../Buttons/Button/Button';
import styled from 'styled-components';
import { TString } from '../Response/Utils';
import Close from '../../../../assets/imgs/close_icon.svg';
import { getImg } from '../../../../src/Utils/getImg';

export interface ButtonItem {
	label?: string | JSX.Element | ReactElement | HTMLElement;
	children?: string | JSX.Element | ReactElement | HTMLElement;
	onClick?: Function;
	loading?: boolean;
	onlyLoader?: boolean;
	disabled?: boolean;
	variant?: 'filled' | 'text' | 'outline';
	fullWidth?: boolean;
}

interface Props {
	heading?: string | JSX.Element | ReactElement | HTMLElement;
	body?: string | JSX.Element | ReactElement | HTMLElement;
	background?: string;
	foreground?: string;
	buttons?: ButtonItem[];
	onClose?: Function;
	className?: string;
	hideClose?: boolean;
	disabled?: boolean;
	children?: string | JSX.Element | ReactElement | HTMLElement;
}

const ModalOverlay = styled.div`
	border-radius: ${(props: any) => {
		return props.curvedEdges ? '8px' : '8px 8px 0px 0px';
	}};
	& .modal-box {
		& .modal-body {
			color: ${(props: any) => {
				return props.foreground ? props.foreground + 'cc' : '#ffffffcc';
			}};
		}
	}
`;

const styleVars = getComputedStyle(document.querySelector(':root'));

export default function ModalPane(props: Props) {
	let background =
		props.background ||
		styleVars.getPropertyValue('--srvMsgBackground') ||
		'#383ff6';
	let foreground =
		props.foreground ||
		styleVars.getPropertyValue('--srvMsgColor') ||
		'#ffffff';
	let x = document.getElementsByClassName('main-container')[0];
	let curvedEdges = x ? x.classList.contains('curved-edges') : false;
	return (
		<ModalOverlay
			className={`modal-pane-overlay ${props.className}`}
			{...{ foreground, background, curvedEdges }}
			onClick={(ev: any) => {
				if (
					props.onClose &&
					(ev.target.classList.contains('modal-pane-overlay') ||
						ev.target.classList.contains('modal-box'))
				) {
					props.onClose();
				}
			}}
		>
			<div className='modal-box'>
				{/* {props.onClose && !props.hideClose ? (
					<div className='modal-close'>
						<IconButton
							variant={'filled'}
							size={'normal'}
							onClick={() => {
								props.onClose();
							}}
							title={TString({ labelName: 'closeLabel' })}
							image={'close'}
						/>
					</div>
				) : null} */}
				<div className='modal-content styled-scroll'>
					{props.onClose && !props.hideClose ? (
						<div
							className='modal-close'
							onClick={() => {
								props.onClose();
							}}
						>
							{/* <IconButton
										variant={'filled'}
										size={'normal'}
										onClick={() => {
											props.onClose();
										}}
										title={TString({ labelName: 'closeLabel' })}
										image={'close'}
									/> */}
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='20'
								height='20'
								viewBox='0 0 20 20'
								style={{ cursor: 'pointer' }}
							>
								<path data-name='Path 24' d='M0 0h20v20H0z' fill='none' />
								<path
									data-name='Path 25'
									d='M16.667 6.175 15.492 5l-4.659 4.658L6.175 5 5 6.175l4.658 4.658L5 15.492l1.175 1.175 4.658-4.658 4.658 4.658 1.175-1.175-4.658-4.658z'
									transform='translate(-.833 -.833)'
									fill='rgba(0,0,0,.4)'
								/>
							</svg>
						</div>
					) : null}
					{props.heading ? (
						<div
							className={`modal-head body-text-1 ${
								props.heading === 'Select Language' ? 'lang-modal-title' : ''
							}`}
						>
							<h3 tabIndex={0} className='modal-title'>
								{props.heading === 'Select Language'
									? TString({ labelName: 'selectLanguageLabel' })
									: props.heading}
							</h3>
						</div>
					) : null}
					{props.body ? (
						<div aria-live='polite' className='modal-body body-text-2'>
							{props.body}
						</div>
					) : null}
					<div
						className='modal-children body-text-1'
						style={{
							marginTop: !props.body && !props.heading ? '0px' : '',
						}}
					>
						{props.children}
					</div>
					{props.buttons ? (
						<div className='modal-buttons'>
							{props.buttons.map((eachButton, key) => (
								<Button
									disabled={props.disabled ? props.disabled : false}
									fullWidth={eachButton.fullWidth ? eachButton.fullWidth : true}
									key={key}
									{...eachButton}
									variant={
										eachButton.variant
											? eachButton.variant
											: key === 0
											? 'filled'
											: 'text'
									}
								/>
							))}
						</div>
					) : null}{' '}
				</div>
			</div>
		</ModalOverlay>
	);
}
